import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import ChatInterface from "./components/ChatInterface";
import ContextManagement from "./components/ContextManagement";
import "./styles.css";

const AIAssistant = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="ai-assistant-container">
      <div className="ai-assistant-header">
        <h2 className="ai-assistant-title">
          <i className="pi pi-comments" style={{ marginRight: "10px" }} />
          Assistente de IA
        </h2>
        <p className="ai-assistant-subtitle">
          Faça perguntas sobre seus dados ou configure o contexto da IA
        </p>
      </div>

      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        className="ai-assistant-tabs"
      >
        <TabPanel
          header="Chat"
          leftIcon="pi pi-comments"
          headerClassName="ai-tab-header"
        >
          <ChatInterface />
        </TabPanel>
        <TabPanel
          header="Gerenciar Contextos"
          leftIcon="pi pi-cog"
          headerClassName="ai-tab-header"
        >
          <ContextManagement />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default AIAssistant;

